<div class="flexGrow">

    <div
        *ngIf="isMobile"
        (click)="toggleOption(1)">
        <div class="flexLeft body3Medium">
            <mat-icon class="blackIcon">
                chevron_left
            </mat-icon>
            {{'settings.options.one' | translate}}
        </div>
    </div>

    <mat-card class="cardGroup">
        <div class="flexBeetwen">
            <p class="subtitle3" *ngIf="!isMobile"> {{'settings.groups.listCard.title' | translate}} </p>
            
            <button *ngIf="!isMobile" mat-raised-button color="primary" class="primaryButton2" (click)="toggleNew()" [disabled]="showNew"> 
                {{'settings.groups.listCard.add' | translate | uppercase}}
            </button>

            <p class="headline6"  *ngIf="isMobile"> {{'settings.groups.listCard.subtitle' | translate}} </p>

            <button *ngIf="isMobile" mat-raised-button color="primary" class="mobileSmallButton" (click)="toggleNew()" [disabled]="showNew"> 
                +
            </button>
        </div>
        <p class="headline6"  *ngIf="!isMobile"> {{'settings.groups.listCard.subtitle' | translate}} </p>
        <app-groups-list></app-groups-list>
    </mat-card>
    <app-groups-new *ngIf="showNew"
        (toggleNewEvent)="toggleNew()">
    </app-groups-new>
</div>
